var _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgEqualPay = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 107.72 107.72",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".c{font-size:6.95px;}.d{letter-spacing:.02em;}.e{letter-spacing:.02em;}.f{letter-spacing:.1em;}.g{fill:#ccdbf1;}.h,.i,.j{fill:#db1170;}.i{font-family:Montserrat-ExtraBold, Montserrat;}.k{letter-spacing:0em;}.l{letter-spacing:0em;}.m{letter-spacing:.01em;}.n{font-size:5.3px;}.o{letter-spacing:.12em;}.p{letter-spacing:.03em;}.j{font-family:Montserrat-Bold, Montserrat;font-size:15.51px;}.q{letter-spacing:0em;}.r{letter-spacing:.03em;}.s{letter-spacing:.04em;}.t{letter-spacing:.04em;}.u{letter-spacing:.04em;}.v{letter-spacing:.04em;}.w{letter-spacing:.14em;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 53.86,
    cy: 53.86,
    r: 51.73
  }), /*#__PURE__*/React.createElement("text", {
    className: "j",
    transform: "translate(33.22 92.29)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "r",
    x: 0,
    y: 0
  }, "2"), /*#__PURE__*/React.createElement("tspan", {
    className: "e",
    x: 9.58,
    y: 0
  }, "0"), /*#__PURE__*/React.createElement("tspan", {
    className: "p",
    x: 20.48,
    y: 0
  }, "23")), /*#__PURE__*/React.createElement("text", {
    className: "i",
    transform: "translate(28.5 20.61)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "c"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "t",
    x: 0,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "v",
    x: 2.29,
    y: 0
  }, "E"), /*#__PURE__*/React.createElement("tspan", {
    className: "u",
    x: 7.23,
    y: 0
  }, "Q"), /*#__PURE__*/React.createElement("tspan", {
    className: "d",
    x: 13.38,
    y: 0
  }, "U"), /*#__PURE__*/React.createElement("tspan", {
    className: "t",
    x: 19.01,
    y: 0
  }, "AL"), /*#__PURE__*/React.createElement("tspan", {
    className: "w",
    x: 29.26,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "l",
    x: 32.25,
    y: 0
  }, "P"), /*#__PURE__*/React.createElement("tspan", {
    className: "q",
    x: 37.33,
    y: 0
  }, "A"), /*#__PURE__*/React.createElement("tspan", {
    className: "u",
    x: 42.76,
    y: 0
  }, "Y")), /*#__PURE__*/React.createElement("tspan", {
    className: "n"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "f",
    x: 0.94,
    y: 6.5
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "m",
    x: 3,
    y: 6.5
  }, "V"), /*#__PURE__*/React.createElement("tspan", {
    className: "s",
    x: 7.14,
    y: 6.5
  }, "\xD5RDNE"), /*#__PURE__*/React.createElement("tspan", {
    className: "o",
    x: 28.79,
    y: 6.5
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "k",
    x: 30.97,
    y: 6.5
  }, "P"), /*#__PURE__*/React.createElement("tspan", {
    className: "s",
    x: 34.84,
    y: 6.5
  }, "ALK"))), /*#__PURE__*/React.createElement("polygon", {
    className: "h",
    points: "55.9 38.49 51.11 40.64 61.64 64.7 66.43 62.55 55.9 38.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "h",
    points: "45.96 42.93 41.17 45.07 51.73 69.03 56.52 66.88 45.96 42.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "h",
    points: "38.28 38.64 32.67 51.62 26.84 38.89 23.98 45.32 23.99 45.35 13.92 67.89 19.75 67.89 26.93 51.8 32.68 64.4 33.21 63.11 41.17 45.08 38.28 38.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "h",
    points: "93.67 39.51 87.8 39.51 80.6 55.83 74.86 43.23 74.1 45.05 66.43 62.55 69.31 68.97 74.96 56.21 80.69 68.74 83.56 62.31 83.54 62.27 93.67 39.51"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 158.94,
    cy: 158.94,
    r: 51.73
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgEqualPay, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/equal-pay.bf64912b.svg";
export { ForwardRef as ReactComponent };